// extracted by mini-css-extract-plugin
module.exports = {"txt":"Inscription_txt__271hD","reserved":"Inscription_reserved__4ezIs","big":"Inscription_big__RHZl7"};